import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { TaskV4Dto } from "@fartherfinance/frontend/api/TaskWorkflows/hooks/useGetTasks";
import { TaskBasicInfo } from "@fartherfinance/frontend/api/TaskWorkflows/Types";
import { TaskId } from "@fartherfinance/frontend/api/Types";

import { useTasksNavigation } from "../hooks";
import TaskStatusIcon from "../TaskStatusIcon/TaskStatusIcon";
import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import TaskProgressChip from "./TaskProgressChip";

import styles from "./TaskSubtaskTooltip.module.css";

interface TaskSubtaskTooltipProps {
  subtasks: TaskBasicInfo[];
  task: TaskV4Dto;
}

const TaskSubtaskTooltip: React.FC<
  React.PropsWithChildren<TaskSubtaskTooltipProps>
> = ({ children, subtasks, task }) => {
  const { handleNavigateToTaskDetails } = useTasksNavigation();

  const navigateToTaskDetails = (
    event: React.MouseEvent<Element, MouseEvent>,
    taskId: TaskId
  ) => {
    event.stopPropagation();
    handleNavigateToTaskDetails(taskId);
  };

  const subtasksListNode = (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerDetails}>
          <Text variant="body" noWrap>
            {task.fields.title}
          </Text>

          <IconButton
            size="small"
            onClick={(event) => navigateToTaskDetails(event, task.id)}
            className={styles.iconButton}
            iconClassName={styles.icon}
            IconComponent={ChevronRightIcon}
          />
        </div>
        <TaskProgressChip variant="counter-only" subtasks={subtasks} />
      </div>

      {subtasks.map((subtask) => (
        <div
          key={subtask.id}
          className={styles.subtask}
          onClick={(event) => navigateToTaskDetails(event, subtask.id)}
        >
          <div className={styles.subtaskDetails}>
            <TaskStatusIcon
              taskStatus={subtask.taskStatus}
              className={styles.subTaskIcon}
            />

            {subtask.taskStatus !== "CANCELED" ? (
              <Text variant="body">{subtask.title}</Text>
            ) : (
              <Text variant="body" color="textSubtle">
                {subtask.title} - Canceled
              </Text>
            )}
          </div>

          <IconButton
            size="small"
            onClick={(event) => navigateToTaskDetails(event, subtask.id)}
            className={styles.iconButton}
            iconClassName={styles.icon}
            IconComponent={ChevronRightIcon}
          />
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip
      classes={{ tooltip: styles.tooltip }}
      tooltipText={subtasksListNode}
      enterDelay={0}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default TaskSubtaskTooltip;
